/* global __CONFIG__ */

import fetch from 'axios';
import qs from 'qs';
import url from 'url';

import { ALERT_ERROR_THEME } from '@coconut/constants/alertBannerThemes';
import { ERROR } from '@coconut/constants/apiStatus';

import { readCookie } from '../cookies';
import { forceLogout } from '../redux/auth';
import { showAlertBanner } from '../redux/alertBanner';
import { getRegion } from '../redux/app';
import { getStore } from '../../store/configureStore';

const TOKEN_INVALID_ERROR_CODE_REGEX = /^(\d{2})-100-0008-(\d{3})$/;

export const getOSType = () => {
  if (navigator.appVersion.indexOf('Win') !== -1) return 'Windows';
  if (navigator.appVersion.indexOf('Android') !== -1) return 'Android';
  if (
    navigator.appVersion.indexOf('Mac') !== -1 &&
    navigator.appVersion.indexOf('Mobile') !== -1
  )
    return 'iOS';
  if (navigator.appVersion.indexOf('Mac') !== -1) return 'MacOS';
  if (navigator.appVersion.indexOf('X11') !== -1) return 'UNIX';
  if (navigator.appVersion.indexOf('Linux') !== -1) return 'Linux';

  return 'Unknown OS';
};

export const buildApiUrl = (apiPath, queries = {}, lang) => {
  const apiUrl = url.parse(`${__CONFIG__.BACKEND_API_ENDPOINT}/${apiPath}`);

  // get pre-existed query
  let queryObject = (apiUrl.query && qs.parse(apiUrl.query)) || {};

  // make sure lang in format: en-HK (regions should be CAPITAL)
  const capitalizedRegionLang = lang.replace(
    /(\w+)-(\w+)/,
    (match, p1, p2) => `${p1}-${p2.toUpperCase()}`
  );

  // merge queries
  queryObject = Object.assign(queryObject, queries, {
    lang: capitalizedRegionLang,
  });

  // if query object is not empty, assign query
  if (Object.keys(queryObject).length) {
    apiUrl.search = qs.stringify(queryObject, { arrayFormat: 'brackets' });
  }

  return apiUrl.format();
};

/**
 * @TODOs
 *  - redirect to login page when token expired.
 *  - implement general http error actions. Dispatch error action.
 *
 * @param {String} path
 * @param {String} method
 * @param {Object} headers
 * @param {Object} options
 */
export const fetchApi = (
  path,
  method = 'GET',
  { headers, params, ...options } = {}
) => {
  // get api url

  const token = readCookie('token');
  const userLng = readCookie('userLng');
  const siteRegion = userLng.slice(-2);
  const deviceId = readCookie('deviceID');
  const reduxStore = getStore().getState();
  const regionInStore = getRegion(reduxStore);
  const os = getOSType();

  const apiUrl = buildApiUrl(path, params, userLng);

  // assign headers
  const fetchHeaders = {
    ...headers,
    'Content-Type': 'application/json',
    'Snapask-User-Agent': JSON.stringify({
      device_id: deviceId,
      os,
      platform: 'web',
    }),
    'Region-Name': regionInStore || siteRegion,
  };

  if (token) {
    fetchHeaders['Snapask-Authorization'] = `Bearer ${token}`;
  }

  return fetch(apiUrl, {
    method,
    headers: fetchHeaders,
    ...options,
  })
    .then((res) => res.data)
    .catch((err) => {
      const {
        response: { data: { error_code: errorCode, status, response } = {} },
      } = err;

      if (TOKEN_INVALID_ERROR_CODE_REGEX.test(errorCode)) {
        getStore().dispatch(forceLogout());
      }

      if (status === ERROR) {
        getStore().dispatch(
          showAlertBanner({
            message: response,
            theme: ALERT_ERROR_THEME,
          })
        );
        throw new Error(response);
      }
    });
};

/**
 * Short handed method for POST
 */
export const postApi = (path, { headers, ...options } = {}) =>
  fetchApi(path, 'POST', {
    headers,
    ...options,
  });

/**
 * Short handed method for GET
 */
export const getApi = (path, { headers, ...options } = {}) =>
  fetchApi(path, 'GET', {
    headers,
    ...options,
  });



// WEBPACK FOOTER //
// ./src/services/apis/utils.js